import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-campaign-planner-schedule-modal',
  templateUrl: './edit-campaign-planner-schedule-modal.component.html',
  styleUrls: ['./edit-campaign-planner-schedule-modal.component.scss'],
})
export class EditCampaignPlannerScheduleModalComponent implements OnInit {
  @Input() scheduleData: any;
  tableData: { day: string; start: string | null; end: string | null }[] = [];
  stepsData: { step: number; time: string }[] = [];

  constructor(public activeModal: NgbActiveModal, private translate: TranslateService) {}

  ngOnInit(): void {
    this.processScheduleData();
    this.processStepsData();
  }

  processScheduleData(): void {
    const days = [
      { key: 'monday', label: this.translate.instant('DAYS.MONDAY') },
      { key: 'tuesday', label: this.translate.instant('DAYS.TUESDAY') },
      { key: 'wednesday', label: this.translate.instant('DAYS.WEDNESDAY') },
      { key: 'thursday', label: this.translate.instant('DAYS.THURSDAY') },
      { key: 'friday', label: this.translate.instant('DAYS.FRIDAY') },
      { key: 'saturday', label: this.translate.instant('DAYS.SATURDAY') },
      { key: 'sunday', label: this.translate.instant('DAYS.SUNDAY') },
    ];

    this.tableData = days.map(day => {
      const isActive = this.scheduleData.data[0][`${day.key}_active`] === 1;
      return {
        day: day.label,
        start: isActive ? this.scheduleData.data[0][`${day.key}_start`] : null,
        end: isActive ? this.scheduleData.data[0][`${day.key}_end`] : null,
      };
    });
  }

  processStepsData(): void {
    this.stepsData = this.scheduleData.data[0].steps.map((step: any) => ({
      step: step.step,
      time: this.formatMinutes(step.time),
    }));
  }

  formatMinutes(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }
}
